var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":_vm.logout}},[_c('i',{staticClass:"tim-icons icon-button-power"}),_vm._v(" "),_c('p',{staticClass:"d-lg-none"},[_vm._v("\n        "+_vm._s(_vm.$t('auth.log-out'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }